'use strict'

import React, { useEffect, useState } from 'react'
import PriceFilter from './priceFilter/PriceFilter'
import PropertyFilter from './propertyFilter/PropertyFilter'
import CategoryFilter from '../categoryFilter/CategoryFilter'

function ProductFilter (props) {
  //console.info(props)

  return (
    <form className={'catalog_form_js'}>
      <span className={'close-filter'} onClick={props.onCloseMobileFilter}/>
      <div className={'filter-title'}>{props.getMessage('FILTERS')}</div>
      <div className={'filter__container'}>
        {
          Array.isArray(props.categories) && props.categories.length ?
            <CategoryFilter categories={props.categories} key={'category'} title={props.getMessage('IN_CATEGORY')}
                            onChange={props.onChange}/> :
            <></>
        }
        {
          props.filters.length ?
            props.filters.map(filter => {
              let key = filter.hasOwnProperty('id') ? filter.id : filter.hasOwnProperty('name') ? filter.name : Math.random()
              return filter.id === 'price' ?
                <PriceFilter {...filter} key={filter.id} onChange={props.onPriceChange}/> :
                <PropertyFilter {...filter} key={key} onChange={props.onChange}/>
            }) :
            <></>
        }
      </div>
    </form>
  )
}

export default ProductFilter